export default "__VITE_ASSET__B45D$RC1__"